export default __webpack_public_path__ + "static/media/IMG_1966.9570edfc.JPG";